import { render, staticRenderFns } from "./ReviewMetadata.vue?vue&type=template&id=a24231fa&scoped=true"
import script from "./ReviewMetadata.vue?vue&type=script&lang=js"
export * from "./ReviewMetadata.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ReviewMetadata.vue?vue&type=style&index=1&id=a24231fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24231fa",
  null
  
)

export default component.exports